import React, {useMemo, useState} from 'react'

import '../assets/css/main.css'
import "bootstrap/dist/css/bootstrap.min.css";

import Header from "../ThemeComponents/Header";
import RedBackground from "../ThemeComponents/RedBackground";
import VehicleTypeOption from "../ThemeComponents/HomePage/VehicleTypeOption";
import SearchField from "../ThemeComponents/HomePage/SearchField";
import BenefitItem from "../ThemeComponents/HomePage/BenefitItem";
import GoogleReviews from "../ThemeComponents/HomePage/GoogleReviews";
import RentTypeFilters from "../ThemeComponents/HomePage/RentTypeFilters";
import Footer from "../ThemeComponents/Footer";

const HomePage = () => {
    const [selectedRentTypes, setSelectedRentTypes] = useState([
        'direct',
        'nearby',
        'online',
        'rental-company'
    ])

    const [vehicleOptions, setVehicleOptions] = useState([
        {
            id: 1,
            title: 'Bestelbus',
            slug: 'bestelbus',
            isActive: true,
            icon: require('../assets/images/bestelbus_option.png')
        },
        {
            id: 2,
            title: 'Personenauto',
            slug: 'personenauto',
            isActive: false,
            icon: require('../assets/images/person_auto_option.png')
        },
        {
            id: 3,
            title: 'Personenbus',
            slug: 'personenbus',
            isActive: false,
            icon: require('../assets/images/personenbus_option.png')
        },
        {
            id: 4,
            title: 'Vrachtwagen',
            slug: 'vrachtwagen',
            isActive: false,
            icon: require('../assets/images/vrachtwagen_option.png')
        },
        {
            id: 5,
            title: 'Accessoires',
            slug: 'accessoires',
            isActive: false,
            icon: require('../assets/images/accessories.png')
        },
        {
            id: 6,
            title: 'Fietsverhuur',
            slug: 'fietsverhuur',
            isActive: false,
            icon: require('../assets/images/bicycle.png')
        }
    ])

    const onVehicleOptionClick = (id) => {
        setVehicleOptions(prev =>
            prev.map(option => ({
                ...option,
                isActive: option.id === id
            }))
        );
    }

    const selectedVehicleType = useMemo(() => {
        return vehicleOptions.find(({isActive}) => isActive)
    }, [vehicleOptions])

    return (
        <>
            <title>New way car rent</title>
            <meta name="description" content="New way car rent" />
            <Header/>
            <div className="front-home-page-hero"
                 style={{backgroundImage: `url(${require('../assets/images/hero.png')})`}}>
                <div className="container">
                    <div className="row front-vehicle-option-container">

                        {
                            vehicleOptions.map(({id, title, isActive, icon}) => {
                                return (
                                    <div className="col-md-2 col-6" key={id}>
                                        <VehicleTypeOption title={title}
                                                           id={id}
                                                           onClick={(selectedId) => onVehicleOptionClick(selectedId)}
                                                           isActive={isActive}
                                                           icon={icon}/>
                                    </div>
                                )
                            })
                        }

                        <div className="col-12 front-rent-type-container mt-3">
                            <RentTypeFilters
                                selectedValues={selectedRentTypes}
                                onChange={setSelectedRentTypes}
                            />
                        </div>

                    </div>

                    <div className="row mt-4">
                        <div className="col-12">
                            <SearchField
                                vehicleType={selectedVehicleType}
                                selectedRentTypes={selectedRentTypes}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <RedBackground>
                <div className="container mt-5">
                    <div className="row">
                        <div className="col-md-8 col-12 bovag-container">
                            <img style={{maxWidth: '100%', height: 'auto'}} src={require('../assets/images/bovag.png')}
                                 alt=""/>
                            <p>Bij Mobility Platform huur je
                                bij BOVAG aangesloten autobedrijven
                                zorgeloos de beste voertuigen voor
                                elk doel</p>
                        </div>
                    </div>
                </div>
            </RedBackground>

            <div className="container">
                <div className="row">
                    <div className="col-md-3">
                        <BenefitItem
                            icon={require('../assets/images/person_auto_option.png')}
                            title="Onze auto’s voldoen aan de BOVAG norm"
                            description="Ruime keuze uit jonge, goed onder-houden voertuigen als auto’s, bestel-bussen, campers en meer. Huren per dag(deel), week of langer, perfect voor tijdelijke behoeften"
                        />
                    </div>
                    <div className="col-md-3">
                        <BenefitItem
                            icon={require('../assets/images/insurance.jpg')}
                            title="All Risk verzekert & heldere voorwaarden"
                            description="Duidelijke, eerlijke huurvoorwaarden en goed onderhouden voertuigen. Inclusief pechhulp, verzekering en wegenbelasting; geen onverwachte kosten."
                        />
                    </div>
                    <div className="col-md-3">
                        <BenefitItem
                            icon={require('../assets/images/map.jpg')}
                            title="Landelijke dekking met meer dan 400 locaties"
                            description="Het voordeel van de grootste; ons platform beidt vervoer altijd in de buurt en waar je tijdelijk vervoer nodig hebt. Ook voor 24/7 keyless verhuur gebruik je ons platform."
                        />
                    </div>
                    <div className="col-md-3">
                        <BenefitItem
                            icon={require('../assets/images/euro.jpg')}
                            title="Scherpe all-in prijzen, geen verrassingen achteraf"
                            description="Bij alle BOVAG-verhuurbedrijven kun je kiezen uit een groot aanbod van voertuigen. Uiteraard zijn ze goed on-derhouden, dus daarmee kun je gega-randeerd veilig op weg."
                        />
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-center">
                        <a className="red-outlined-btn" href="#">Klik hier voor alle deelnemende BOVAG autoverhuurbedrijven</a>
                    </div>
                </div>
            </div>

            <section className="container">
                <div className="row mt-5">
                    <div className="col-12">
                        <h2 className="front-dark-title-2 text-center">Een voertuig huren via het Mobility Platform is een bewezen concept. Lees zelf maar!</h2>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-12" style={{overflow: 'hidden'}}>
                        <GoogleReviews />
                    </div>
                </div>
            </section>

            <section className="front-red-bg mt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4">
                            <h3 className="red-title-2">Voertuig huren</h3>
                            <ul className="front-footer-links">
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.autohopper.nl/goedkoop-auto-huren">Goedkoop een auto huren</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.autohopper.nl/goedkoop-busje-huren">Goedkoop een bus huren</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.autohopper.nl/verhuiswagen-huren">Verhuiswagen huren</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.autohopper.nl/elektrische-auto-huren">Elektrische auto
                                    huren</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.autohopper.nl/vrachtwagen-huren">Vrachtwagen huren</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.autohopper.nl/be-combi-huren">BE-Combi huren</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.autohopper.nl/vip-bus-huren">VIP-bus huren</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/amsterdam">Auto huren Amsterdam</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/utrecht">Auto huren Utrecht</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/rotterdam">Auto huren Rotterdam</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/den-haag">Auto huren Den Haag</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/groningen">Auto huren Groningen</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/eindhoven">Auto huren Eindhoven</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/amersfoort">Auto huren Amersfoort</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/nijmegen">Auto huren Nijmegen</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/auto-huren/arnhem">Auto huren Arnhem</a>
                                </li>
                                <li><a target="_blank" referrerPolicy="no-referrer"
                                       href="https://www.snappcar.nl/steden">Overige steden...</a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <h3 className="red-title-2">Mobility Platform</h3>
                            <ul className="front-footer-links">
                                <li><a
                                    href="#">Over Mobility Platform</a>
                                </li>
                                <li><a
                                    href="#">Pech of schade</a>
                                </li>
                                <li><a
                                    href="#">Huurtijden</a>
                                </li>
                                <li><a
                                    href="#">Acties</a>
                                </li>
                                <li><a
                                    href="#">Verhuren via het platform</a>
                                </li>
                                <li><a
                                    href="#">Blog</a>
                                </li>
                                <li><a
                                    href="#">Nieuws</a>
                                </li>
                                <li><a
                                    href="#">Vacatures</a>
                                </li>
                                <li><a
                                    href="#">Contact</a>
                                </li>
                                <li><a
                                    href="#">Veelgestelde vragen</a>
                                </li>
                                <li><a
                                    href="#">Dealerportaal</a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-4">
                            <h3 className="red-title-2">Zakelijk</h3>
                            <ul className="front-footer-links">
                                <li><a
                                    href="#">Bedrijfswagen leasen</a>
                                </li>
                                <li><a
                                    href="#">Flexibel leasen</a>
                                </li>
                                <li><a
                                    href="#">Lease auto en hypotheek</a>
                                </li>
                                <li><a
                                    href="#">Promo</a>
                                </li>
                                <li><a
                                    href="#">Private lease</a>
                                </li>
                                <li><a
                                    href="#">Shortlease</a>
                                </li>
                                <li><a
                                    href="#">Zakelijk leasen als ZZP'er</a>
                                </li>
                                <li><a
                                    href="#">Zakelijk leasen berekenen</a>
                                </li>
                                <li><a
                                    href="#">Zakelijk leasen</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

        </>

    )
}

export default HomePage
